import {styled} from "@mui/material/styles";
import {TableContainer} from "@mui/material";

export const FixedTableContainer = styled(TableContainer)(
    ({theme}) => ({
        height: '90%'
    })
);